import { memo, useState } from 'react';

import { useIsDesktop } from 'hooks/useIsDesktop';

import { MobileHeader } from './MobileHeader';
import { DesktopHeader } from './DesktopHeader';
import { ContactModal } from './ContactModal';

export const Header = memo(() => {
  const isDesktop = useIsDesktop();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen((value) => !value);

  return (
    <>
      {isDesktop ? (
        <DesktopHeader openModal={toggleModal} />
      ) : (
        <MobileHeader openModal={toggleModal} />
      )}
      <ContactModal onClose={toggleModal} isOpen={isModalOpen} />
    </>
  );
});
